import React from 'react';
import styled from 'styled-components';

const StyledError = styled.div`
  width: 100%;
  color: red;
  font-size: large;
  font-weight: 600;
  display: flex;
  justify-content: center;
`;

export const EnvIssue = () => (
  <>
    <StyledError>Error with variables. Contact Support.</StyledError>
  </>
);

export default EnvIssue;
